import chatcontainer from "./chat-container.html";

const chatHandler = require('./chat-handler')
const chatActions = require('./chat-actions')

/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false
let data = {};

function HTMLselect(detail) {

    const sourceElement = detail.ev?.target || null;

    chatActions.HTMLselect(
        'chat',
        'chat-container',
        sourceElement,
        chatcontainer,
        htmlQf
    )

    HTMLwasSelected = true
}

export function start(detail) {
    if (!HTMLwasSelected) { HTMLselect(detail) }
    obj[detail.actQuickview].start(detail)
}

const obj = {

    show:           { start: (detail) => { show(detail)                     } },
    hide:           { start: (detail) => { chatActions.hide(detail, htmlQf) } },
    submit:         { start: (detail) => { submit(detail)                   } },
    sendQuestion:   { start: (detail) => { sendQuestion(detail)             } },
}

function show(detail) {
    // se limpia la variable general
    data = "";
    // se asigna los valores de detail a la variable general data
    data = detail;
    // se muestra el quickview para poder acceder a los elementos
    chatActions.show(detail, htmlQf)
    // se limpia el chat
    chatActions.clearChat()
    // se obtienen los labels estaticos
    const chatContainer = document.getElementById("chat-container");
    const chatType = chatContainer.querySelector(".chat-type");
    chatType.innerHTML = "";
    // se limpian los labels antes de inserta entidad y tipo
    // se manejan datos especificos para ejecutar verificaciones especificas
    const recordId = data.recordId || 0;
    const question = detail.question || "";
    // si existe una pregunta al momento de mostrar el chat
    if (question !== "") {
        chatActions.setTextInput(question)
        chatHandler.submit({
            "type": data.type,
            "entity": data.entity,
            "recordId": recordId,
            "question": question,
            "data": data.data
        })
    }
    // se el id de la factura es diferente de 0
    if (recordId !== 0) {
        chatHandler.getChats({
            "type": data.type,
            "entity": data.entity,
            "recordId": recordId
        })
    }
    // se asigna el valor valor a los labels especificos
    chatType.innerHTML = data.cardWarning;
    renderQuestions(detail)
    // se limpia la caja de escritura
    chatActions.clearTextInput()
}

function submit(detail) {
    const question = chatActions.getTextInput(detail);
    if (question === '') return;

    chatHandler.submit({
        "type": data.type,
        "entity": data.entity,
        "recordId": data.recordId ?? "0",
        "question": question,
        "data": data.data
    })
}

function sendQuestion(detail) {
    chatActions.setTextInput(detail.question)
    const question = chatActions.getTextInputFrequent(detail);

    chatHandler.submit({
        "type": data.type,
        "entity": data.entity,
        "recordId": data.recordId ?? "0",
        "question": question,
        "data": data.data
    })
}

function renderQuestions(detail) {
    const chatContainer = document.getElementById("chat-container");
    if (!chatContainer) return;

    const questionsContainer = chatContainer.querySelector(".chat-question");
    if (!questionsContainer) return;

    const generalQuestions = Array.isArray(detail.generalQuestions) ? detail.generalQuestions : [];

    if (generalQuestions.length === 0) {
        questionsContainer.innerHTML = "";
        questionsContainer.style.display = "none";
        return;
    }

    questionsContainer.style.display = "";
    let html = "";

    for (let i = 0; i < generalQuestions.length; i += 2) {
        const link = buildQuestionItemHTML(generalQuestions[i]);
        const link2 = buildQuestionItemHTML(generalQuestions[i + 1]);

        html += `
                ${link}
                ${link2}
        `;
    }

    questionsContainer.innerHTML = html;
}

function buildQuestionItemHTML(question) {
    if (!question || typeof question !== "string") return "";

    const detailObj = JSON.stringify({
        click: [
            { dest: "ripple" },
            { dest: "chat", act: "quickview", actQuickview: "sendQuestion", question: question }
        ]
    });

    return `
        <div class="font-icon font-icon-link ta-l">
            <span class="cont">
                <span></span>
                <span class="chat-question-text" data-detail='${detailObj}'>${question}</span>
                <span></span>
            </span>
        </div>
    `;
}